import { toast } from '@/hooks/use-toast';
import { AxiosError } from 'axios';

export function handleQueryError(error: unknown): void {
  const message = error instanceof Error ? error.message : 'Erro inesperado';
  
  // Check if it's an axios error with response
  const response = error instanceof AxiosError ? error.response : undefined;
  
  if (response?.status === 401) {
    // Token expired - redirect to login
    toast({
      title: 'Sessão expirada',
      description: 'Por favor, faça login novamente.',
      variant: 'destructive',
      // `priority` porque este é o ÚNICO toast que explica o redirect que vem
      // logo abaixo. O `onError` local de qualquer mutation roda depois deste
      // handler global e, com TOAST_LIMIT = 1, substituía o aviso — o usuário
      // caía no login lendo o erro específico da ação, que nada tinha a ver
      // com o que acabou de acontecer com ele (ATR-625).
      priority: true,
    });
    // Small delay to show toast before redirect
    setTimeout(() => {
      window.location.href = '/login';
    }, 1000);
    return;
  }
  
  if (response?.status === 429) {
    toast({
      title: 'Muitas requisições',
      description: 'Aguarde um momento antes de tentar novamente.',
      variant: 'destructive',
    });
    return;
  }
  
  if (response?.status === 403) {
    toast({
      title: 'Acesso negado',
      description: 'Você não tem permissão para realizar esta ação.',
      variant: 'destructive',
    });
    return;
  }
  
  if (response?.status === 404) {
    toast({
      title: 'Não encontrado',
      description: 'O recurso solicitado não foi encontrado.',
      variant: 'destructive',
    });
    return;
  }
  
  if (response?.status && response.status >= 500) {
    toast({
      title: 'Erro no servidor',
      description: 'Ocorreu um erro no servidor. Tente novamente mais tarde.',
      variant: 'destructive',
    });
    return;
  }
  
  // Generic error
  toast({
    title: 'Erro',
    description: message,
    variant: 'destructive',
  });
}
